import { Component, type ReactNode } from 'react'

interface Props {
	children: ReactNode
}

interface State {
	hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false }
	}

	static getDerivedStateFromError(): State {
		return { hasError: true }
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex min-h-screen items-center justify-center">
					<div className="text-center">
						<h1 className="mb-4 text-2xl font-bold text-stone-900">
							Что-то пошло не так
						</h1>
						<p className="mb-4 text-stone-600">
							Приносим извинения за неудобства. Попробуйте обновить страницу.
						</p>
						<button
							onClick={() => window.location.reload()}
							className="rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
						>
							Обновить страницу
						</button>
					</div>
				</div>
			)
		}

		return this.props.children
	}
}
